@if (pagesResult$ | async; as pages) {
  <div role="status" aria-live="polite" class="visuallyhidden">
    {{ 'v_table_has_been_loaded' | translate: ('view_by' | translate) + ' ' + ('page' | translate) }}
  </div>
  <div class="row mb-3">
    <div class="col-auto d-flex align-items-center flex-grow-1">
      <span class="text-black me-2">{{ 'search_by_url' | translate }}</span>
      <input class="w-25 form-control" type="text" [(ngModel)]="urlQueryTerm" (keyup.enter)="getPages$.next(undefined)" />
      <button class="btn btn-outline-primary ms-2" (click)="getPages$.next(undefined)">
        {{ 'form_search' | translate }}
      </button>
    </div>
    <div class="col-auto">
      <span class="text-black me-3" id="entriesPerPage">{{ 'label_rows_per_page' | translate }}</span>
      <select [(ngModel)]="entriesPerPage" (ngModelChange)="getPages$.next(undefined)" aria-labelledby="entriesPerPage">
        @for (limit of DEFAULT_ENTRY_LIMITS; track $index) {
          <option [ngValue]="limit">
            {{ limit }}
          </option>
        }
      </select>
    </div>
    <div class="col-auto d-flex align-items-center">
      <span class="me-3 text-black">{{ getPaginationLabel(page, entriesPerPage, totalPages) }}</span>
      <ngb-pagination
        class="d-flex align-items-center"
        [attr.aria-label]="'label_pages_scanned_pagination' | translate"
        [(page)]="page"
        [pageSize]="entriesPerPage"
        [collectionSize]="totalPages"
        (pageChange)="getPages$.next(undefined)"
      >
        <ng-template ngbPaginationPrevious>{{ 'label_previous' | translate }}</ng-template>
        <ng-template ngbPaginationNext>{{ 'label_next' | translate }}</ng-template>
        <ng-template ngbPaginationNumber let-pageNum>
          <span class="visually-hidden">
            {{ (pageNum !== page ? 'go_to_page' : 'page') | translate }}
            &nbsp;
          </span>
          {{ pageNum }}
        </ng-template>
      </ngb-pagination>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <app-ngb-table [config]="tableConfig" [data]="pages" (onSort)="onTableSort($event)"> </app-ngb-table>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12 d-flex justify-content-end align-items-center">
      <span class="me-3 text-black">{{ getPaginationLabel(page, entriesPerPage, totalPages) }}</span>
      <ngb-pagination
        class="d-flex align-items-center"
        [attr.aria-label]="'label_pages_scanned_pagination' | translate"
        [(page)]="page"
        [pageSize]="entriesPerPage"
        [collectionSize]="totalPages"
        (pageChange)="getPages$.next(undefined)"
      >
        <ng-template ngbPaginationPrevious>{{ 'label_previous' | translate }}</ng-template>
        <ng-template ngbPaginationNext>{{ 'label_next' | translate }}</ng-template>
        <ng-template ngbPaginationNumber let-pageNum>
          <span class="visually-hidden">
            {{ (pageNum !== page ? 'go_to_page' : 'page') | translate }}
            &nbsp;
          </span>
          {{ pageNum }}
        </ng-template>
      </ngb-pagination>
    </div>
  </div>
}
